/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_Decks_AllInputs */



/**
* | output |
* | --- |
* | "All decklists become public" |
*
* @param {Finish_Confirm_Decks_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_decks_all = /** @type {((inputs?: Finish_Confirm_Decks_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Decks_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les decklists deviennent publiques")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las decklists se hacen públicas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as decklists se tornam públicas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le decklist diventano pubbliche")
	return /** @type {LocalizedString} */ ("All decklists become public")
});